<template>
  <div>
    <el-form-item label="银行卡号"
                  prop="bank_card_number">
      <el-input v-model="formData.bank_card_number"
                placeholder="请输入银行卡号"></el-input>
    </el-form-item>
    <el-form-item label="银行名称"
                  prop="bank_name">
      <el-input v-model="formData.bank_name"
                placeholder="请输入银行名称,例如 中国工商银行"></el-input>
    </el-form-item>
    <el-form-item label="开户支行"
                  prop="bank_branch_name">
      <el-input v-model="formData.bank_branch_name"
                placeholder="请输入开户支行,例如 普陀祁连山南路支行"></el-input>
    </el-form-item>
    <el-form-item label="银行卡照片"
                  prop="bank_card_photo">
      <el-upload ref="bankCardUpload"
                 class="upload-demo"
                 :auto-upload="false"
                 action=""
                 :file-list="bankCardPhotoList"
                 list-type="picture-card"
                 accept=".jpg,.jpeg,.png"
                 :on-change="(file, fileList) => onChangeFile(file, fileList, 'bank_card_photo')"
                 :on-remove="(file, fileList) => handleRemove(file, fileList, 'bank_card_photo')">
        <i class="el-icon-plus"></i>
      </el-upload>
    </el-form-item>
    <el-form-item label="身份证号"
                  prop="id_number">
      <el-input v-model="formData.id_number"
                placeholder="请输入身份证号"></el-input>
    </el-form-item>
    <el-form-item label="身份证照片(正反面)"
                  prop="id_card_photos">
      <div class="id-card-upload-wrapper">
        <div class="id-card-item">
          <el-upload ref="idCardFrontUpload"
                     class="avatar-uploader id-card-uploader"
                     :auto-upload="false"
                     action=""
                     :show-file-list="false"
                     accept=".jpg,.jpeg,.png"
                     :on-change="(file, fileList) => onChangeFile(file, fileList, 'id_card_front_photo')"
                     :on-remove="() => handleRemove(null, null, 'id_card_front_photo')">
            <img v-if="formData.id_card_front_photo"
                 :src="formData.id_card_front_photo"
                 class="id-card-avatar"/>
            <div v-else
                 class="id-card-placeholder">
              <i class="el-icon-plus"></i>
              <span>正面</span>
            </div>
          </el-upload>
        </div>
        <div class="id-card-item">
          <el-upload ref="idCardBackUpload"
                     class="avatar-uploader id-card-uploader"
                     :auto-upload="false"
                     action=""
                     :show-file-list="false"
                     accept=".jpg,.jpeg,.png"
                     :on-change="(file, fileList) => onChangeFile(file, fileList, 'id_card_back_photo')"
                     :on-remove="() => handleRemove(null, null, 'id_card_back_photo')">
            <img v-if="formData.id_card_back_photo"
                 :src="formData.id_card_back_photo"
                 class="id-card-avatar"/>
            <div v-else
                 class="id-card-placeholder">
              <i class="el-icon-plus"></i>
              <span>反面</span>
            </div>
          </el-upload>
        </div>
      </div>
    </el-form-item>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    internId: {
      type: String,
      default: '0',
    },
  },
  data () {
    return {
      bankCardPhotoList: []
    }
  },
  computed: {
    formData: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  watch: {
    'formData.bank_card_photo': {
      handler (newVal) {
        // 只在 bankCardPhotoList 为空时初始化，避免后续操作导致闪烁
        if (this.bankCardPhotoList.length === 0 && newVal && newVal.length > 0) {
          this.bankCardPhotoList = newVal.map(url => ({url, status: 'ready'}))
        }
      },
      immediate: true
    }
  },
  methods: {
    reset () {
      // 清空表单数据
      this.formData.id_number = ''
      this.formData.id_card_front_photo = ''
      this.formData.id_card_back_photo = ''
      this.formData.bank_name = ''
      this.formData.bank_branch_name = ''
      this.formData.bank_card_number = ''
      this.formData.bank_card_photo = []
      this.bankCardPhotoList = []
    },
    handleRemove (file, fileList, field) {
      if (field === 'bank_card_photo') {
        // 同时更新 photoList 和 formData
        this.bankCardPhotoList = fileList.map(item => ({...item, status: 'ready'}))
        this.formData[field] = fileList.map(item => item.response || item.url)
      } else if (['id_card_front_photo', 'id_card_back_photo'].includes(field)) {
        this.formData[field] = ''
      }
    },
    async onChangeFile (file, fileList, field) {
      const isImage = file.raw.type === 'image/jpeg' || file.raw.type === 'image/png'
      const isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('请上传jpg/png图片!')
        this.removeInvalidFile(file, fileList, field)
        return false
      }
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        this.removeInvalidFile(file, fileList, field)
        return false
      }
      const fieldMap = {
        'id_card_front_photo': 'intern_idcard_front',
        'id_card_back_photo': 'intern_idcard_back',
        'bank_card_photo': 'intern_bankcard'
      }
      const apiField = _.get(fieldMap, field, field)

      try {
        const result = await this.uploadFile(file.raw, apiField)
        if (result.success) {
          if (field === 'bank_card_photo') {
            // 上传成功，更新最后一个文件的 response
            const lastFile = fileList[fileList.length - 1]
            lastFile.response = result.url
            this.bankCardPhotoList = fileList.map(item => ({...item, status: 'ready'}))
            this.formData[field] = fileList.map(item => item.response || item.url)
          } else if (['id_card_front_photo', 'id_card_back_photo'].includes(field)) {
            this.formData[field] = result.url
          }
        } else {
          this.$message.error(result.error || '上传失败')
          this.removeInvalidFile(file, fileList, field)
        }
      } catch (err) {
        this.$message.error(err.message || '上传失败')
        this.removeInvalidFile(file, fileList, field)
      }
    },
    removeInvalidFile (file, fileList, field) {
      const index = fileList.indexOf(file)
      if (index > -1) {
        fileList.splice(index, 1)
        if (field === 'bank_card_photo') {
          // 同时更新 photoList 和 formData
          this.bankCardPhotoList = fileList
          this.formData[field] = fileList.map(item => item.response || item.url)
        }
      }
    },
    getExtByBlob (blob) {
      const fileName = blob.name || 'file.jpg'
      const ext = fileName.substring(fileName.lastIndexOf('.')).toLowerCase()
      return ext || '.jpg'
    },
    async uploadFile (file, field) {
      try {
        const blob = file.raw || file
        // 获取签名URL
        const params = {
          intern_id: this.internId,
          ext: this.getExtByBlob(blob),
          content_type: blob.type,
          oss_tpl: field
        }
        const res = await request.common('getOssSignedUrlApi', params)

        if (res.status === 200) {
          const uploadUrl = res.data.signedUrl
          const contentType = res.data.content_type
          const fileUrl = res.data.url
          // 上传文件到签名URL
          const uploadRes = await fetch(uploadUrl, {
            method: 'PUT',
            headers: new Headers({'Content-Type': contentType}),
            body: blob
          })
          if (!uploadRes.ok) {
            return {success: false, error: `上传失败: ${uploadRes.status} ${uploadRes.statusText}`}
          } else {
            return {success: true, url: fileUrl}
          }
        }
        return {success: false, error: '获取上传地址失败'}
      } catch (err) {
        return {success: false, error: err.message || '上传失败'}
      }
    }
  }
}
</script>

<style lang="scss"
       scoped>
.id-card-upload-wrapper {
  display: flex;
  gap: 16px;
}

.id-card-item {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.id-card-uploader .el-upload {
  width: 100px;
  height: 100px;
  line-height: 80px;
}

.id-card-placeholder {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  color: #8c939d;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.id-card-placeholder:hover {
  border-color: #409EFF;
}

.id-card-placeholder i {
  font-size: 20px;
  margin-bottom: 4px;
}

.id-card-placeholder span {
  font-size: 12px;
}

.id-card-avatar {
  font-size: 10px;
  width: 100px;
  height: 100px;
  display: block;
  object-fit: cover;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
}
</style>



// WEBPACK FOOTER //
// src/views/audit-intern/components/PrivateInfoForm.vue